import { defineStore } from 'pinia';
import { store } from '../index';
import { UserLoginType, UserType } from '@/api/login/types';
import { ElMessageBox } from 'element-plus';
import router from '@/router';
// 去掉相互引用
interface UserState {
  userInfo?: UserType;
  tokenKey: string;
  token: string;
  roleRouters?: string[] | AppCustomRouteRecordRaw[];
  rememberMe: boolean;
  loginInfo?: UserLoginType;
  hospitalVoList: any[];
  buttonList: any[]; // 按钮权限数组
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      tokenKey: 'Access-Token',
      token: '',
      roleRouters: undefined,
      // 记住我
      rememberMe: true,
      loginInfo: undefined,
      hospitalVoList: [],
      buttonList: [],
    };
  },
  getters: {
    // 获取权限数组
    getButtonList(): any[] {
      return this.buttonList;
    },

    getTokenKey(): string {
      return this.tokenKey;
    },
    getToken(): string {
      return this.token;
    },
    getUserInfo(): UserType | undefined {
      return this.userInfo;
    },
    getRoleRouters(): string[] | AppCustomRouteRecordRaw[] | undefined {
      return this.roleRouters;
    },
    getRememberMe(): boolean {
      return this.rememberMe;
    },
    getLoginInfo(): UserLoginType | undefined {
      return this.loginInfo;
    },
    getHospitalVoList(): any[] {
      return this.hospitalVoList;
    },
  },
  actions: {
    // 设置按钮权限数组
    setButtonList(list: any[]) {
      this.buttonList = list;
    },
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey;
    },
    setToken(token: string) {
      this.token = token;
    },
    setUserInfo(userInfo?: UserType) {
      this.userInfo = userInfo;
    },
    setHospitalVoList(list: any[]) {
      this.hospitalVoList = list;
    },
    setRoleRouters(roleRouters: string[] | AppCustomRouteRecordRaw[]) {
      this.roleRouters = roleRouters;
    },
    logoutConfirm() {
      ElMessageBox.confirm('是否退出本系统？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 不调用接口，先注释掉
          // const res = await loginOutApi().catch(() => {})
          // if (res) {
          //   this.reset()
          // }
          this.reset();
        })
        .catch(() => {});
    },
    async reset() {
      // 使用异步导入
      const { useTagsViewStoreWithOut } = await import('./tagsView');
      const tagsViewStore = useTagsViewStoreWithOut();
      tagsViewStore.delAllViews();
      this.setToken('');
      this.setUserInfo(undefined);
      this.setRoleRouters([]);
      router.replace('/login');
    },
    logout() {
      this.reset();
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe;
    },
    setLoginInfo(loginInfo: UserLoginType | undefined) {
      this.loginInfo = loginInfo;
    },
  },
  persist: true,
});

export const useUserStoreWithOut = () => {
  return useUserStore(store);
};
